import { aiTutorFragment } from "./AITutorFlaggedMessagesFragments";
import { gql } from "lib/apolloClient";

export const getAIConversationsFlaggedMessagesQuery = gql`
  query getAiConversationsFlaggedMessages($id: ID!) {
    node(id: $id, type: STUDENT_ASSIGNMENT) {
      ... on StudentAssignment {
        id
        aiConversations(orderBy: CREATED_AT, orderByDirection: DESC) {
          edges {
            node {
              ...aiConversationForFlaggedMessagesItem
            }
          }
        }
      }
    }
  }
  ${aiTutorFragment.aiConversationForFlaggedMessages}
`;

export const getAIConversationFlaggedMessagesQuery = gql`
  query getAIConversationFlaggedMessages($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        ...aiConversationForFlaggedMessagesItem
      }
    }
  }
  ${aiTutorFragment.aiConversationForFlaggedMessages}
`;
